// extracted by mini-css-extract-plugin
export default {"scrollTop":"ScrollToTop_scrollTop__o5vtu"};